import { SelectOptions } from 'shared/models/general.ts'

export interface AppealTicket {
  phone: string
  email?: string
  files?: File[]
  subject?: string
  description?: string
  typeFeedback?: string
  passengers?: SelectOptions[]
}

export enum APPEAL_TYPES {
  APPEAL_TOPIC = 'appeals_topic',
  REFUND_TICKET_SUBJECTS = 'refund_ticket_subjects',
  TRADE_TICKET_SUBJECTS = 'trade_ticket_subjects',
  ADDITIONAL_SERVICE_SUBJECTS = 'additional_service_subjects',
  OTHER_SUBJECTS = 'other_subjects',
}
